// 引入样式
require('./style/index.scss');
import $ from 'jquery';
import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';
import '../node_modules/swiper/swiper-bundle.css';

Swiper.use([Autoplay, Pagination, Navigation])


// pc页面相关js
// 直播回顾
$('#backView .list-item').on('click', function (e) {
  $(this).addClass('on').siblings().removeClass('on');
  var videoSrc = $(this).attr('data-src');
  $("#videoN")[0].src = videoSrc;
  $("#videoN")[0].play();
});

// 精彩回顾
var certifySwiper = new Swiper('#certify .swiper', {
  watchSlidesProgress: true,
  slidesPerView: 'auto',
  centeredSlides: true,
  init: true,
  loop: true,
  loopedSlides: 5,
  autoplay: {
    disableOnInteraction: false,
    delay: 2000,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    progress: function (progress) {
      var modify = null;
      var translate = null;
      var scale = null;
      var zIndex = null;
      for (var i = 0; i < this.slides.length; i++) {
        var slide = this.slides.eq(i);
        var slideProgress = this.slides[i].progress;
        modify = 1;
        if (Math.abs(slideProgress) > 1) {
          modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
        }
        translate = slideProgress * modify * 260 + 'px';
        scale = 1 - Math.abs(slideProgress) / 5;
        zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
        slide.css('zIndex', zIndex);
        slide.css('opacity', 1);
        if (Math.abs(slideProgress) > 3) {
          slide.css('opacity', 0);
        }
      }
    },
    setTransition: function (transition) {
      for (var i = 0; i < this.slides.length; i++) {
        var slide = this.slides.eq(i)
        slide.transition(transition);
      }
    }
  }
})



// h5页面相关js
// 直播回顾
$("#mobileBackView .play-right").on('click', function (e) {
  $("#mobileBackView .play-list").show()
})
// 播放列表弹出层
var mask = $('#mobileBackView .play-list');
$(document).on('click', function (e) {
  var target = $(e.target);
  if (!target.hasClass('play-right') && target.closest(mask).length == 0) {
    $(mask).hide();
  } else if (target.hasClass('play-right') && target.closest(mask).length == 0) {
    $(mask).show();
  }
})
// 关闭按钮
$("#closeMask").on('click', function () {
  mask.hide();
})
$('#mobileBackView .play-list__item').on('click', function (e) {
  $(this).addClass('on').siblings().removeClass('on');
  var mobileVideoSrc = $(this).attr('data-src');
  $("#mobileVideo")[0].src = mobileVideoSrc;
  $("#mobileVideo")[0].play();
  var h3 = $(this).children('h3').html()
  var p = $(this).children('p').html()
  $("#playOnText").children('h3').html(h3)
  if (p) {
    $("#playOnText").children('p').html(p).show()
  } else {
    $("#playOnText").children('p').html('').hide()
  }
  mask.hide()
});

// 精彩回顾 swiper
var sLength = $("#mobileReviewSwiper .swiper-slide").length
$("#mobileReviewSwiper .progress").html('1/' + sLength)
var swiper = new Swiper('#mobileReviewSwiper .swiper', {
  watchSlidesProgress: true,  //查看slide的progress
  resistanceRatio: 0, //禁止边缘移动
  // autoplay: {
  //   disableOnInteraction: false,
  //   delay: 2000,
  // },
  on: {
    init: function () {
      var slides = this.slides
      var slide = null;
      for (var i = 0; i < slides.length; i++) {
        slide = slides.eq(i)
        slide.css('zIndex', 100 - i);  //设置slide的z-index层级
      }
    },

    resize: function (swiper) {
      swiper.update()
    },

    setTranslate: function () {
      var slides = this.slides
      var offsetAfter = this.width * 0.9 //每个slide的位移值
      var progress = null;
      var slide = null;
      for (var i = 0; i < slides.length; i++) {
        slide = slides.eq(i)
        progress = slides[i].progress

        if (progress <= 0) {  //右边slide位移
          slide.transform('translate3d(' + (progress) * offsetAfter + 'px, 0, 0) scale(' + (1 - Math.abs(progress) / 9) + ')');
          slide.css('opacity', (progress + 3));    //最右边slide透明
        }

        if (progress > 0) {
          slide.transform('rotate(' + (-progress) * 5 + 'deg)');   //左边slide旋转
          slide.css('opacity', 1 - progress);    //左边slide透明
        }
      }
    },
    setTransition: function (swiper, transition) {
      for (var i = 0; i < this.slides.length; i++) {
        var slide = this.slides.eq(i)
        slide.transition(transition);
      }
    },

    slideChange: function () {
      $("#mobileReviewSwiper .progress").html(this.activeIndex + 1 + '/' + sLength)
    },
  },
});

let arr = [];
let body = document.documentElement || document.body;
let speed = 50; //页面移动速度
let range = 100;

const getHeightArr = () => {
  arr = [];
  arr.push(
    $("#backView")[0].offsetTop - range,
    $("#background")[0].offsetTop - range,
    $("#guest")[0].offsetTop - range,
    $("#focus")[0].offsetTop - range,
    $("#arrange")[0].offsetTop - range,
    $("#review")[0].offsetTop - range,
    $("#report")[0].offsetTop - range,
    $("#supptor")[0].offsetTop - range
  );
}

getHeightArr();

// 最后一次一定执行
const throttle = (fn, time = 100) => {
  let timer = null;
  return function (...args) {
    if (!timer) {
      timer = setTimeout(() => {
        timer = null;
        fn.apply(this, args);
      }, time);
    }
  }
}

const smoothUp = (local, target) => { // 当前高度   期望高度
  let curr = local;
  if (local > target) {
    curr -= speed;
    body.scrollTop = curr;
    requestAnimationFrame(() => {
      smoothUp(curr, target)
    });
  } else {
    body.scrollTop = target;
  }
}

const smoothDown = (local, target) => { // 当前高度  期望高度
  let curr = local;
  if (local < target) {
    curr += speed;
    body.scrollTop = curr;
    requestAnimationFrame(() => {
      smoothDown(curr, target)
    });
  } else {
    body.scrollTop = target;
  }
}

const handleScroll = () => {
  let index = -1;
  let scrollTop = body.scrollTop;
  if (scrollTop >= arr[7] - 300) {
    index = 7;
  } else if (scrollTop >= arr[6]) {
    index = 6;
  } else if (scrollTop >= arr[5]) {
    index = 5;
  } else if (scrollTop >= arr[4]) {
    index = 4;
  } else if (scrollTop >= arr[3]) {
    index = 3;
  } else if (scrollTop >= arr[2]) {
    index = 2;
  } else if (scrollTop >= arr[1]) {
    index = 1;
  } else if (scrollTop >= arr[0]) {
    index = 0;
  }
  if(index >= 0) {
    $("#nav").show()
  } else {
    $("#nav").hide()
  }
  $("#nav li").each(function (itemIndex) {
    $(this).removeClass("liActive");
    if (itemIndex === index) {
      $(this).addClass("liActive");
    }
  })
}

// 算法没问题，莫名的原因。导致不+10锚点调换会有点异常
$("#nav li").each(function (index) {
  $(this).on('click', function () {
    let scrollTop = body.scrollTop
    if (scrollTop > arr[index]) {
      smoothUp(scrollTop, arr[index] + 10)
    } else if (scrollTop < arr[index]) {
      smoothDown(scrollTop, arr[index] + 10)
    }
  })
})

window.addEventListener("scroll", throttle(handleScroll));

window.addEventListener('resize', () => {
  getHeightArr();
});
